// FloatingLabelInput.jsx
import React, { useState } from 'react';

export const BASIC_CASES =
  'rounded-lg  bg-primary-50 p-2 block w-full  border-2 border-b-gray-300 focus:outline-none w-full';

const Input = ({ label, name, type = 'text', ...rest }) => {
  const [isFocused, setFocus] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const handleFocus = () => setFocus(true);
  const handleBlur = (e) => {
    setFocus(e.target.value !== '');
    setIsFilled(e.target.value !== '');
  };

  return (
    <div className=" w-full">
      <input
        id={name}
        name={name}
        type={type}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`${BASIC_CASES} ${
          isFocused ? '!border-primary-300 border-2' : ''
        } ${isFilled ? 'font-bold text-primary-700' : ''}`}
        placeholder={label}
        {...rest}
      />
    </div>
  );
};

export default Input;
